export class EmailFileModel {
    constructor(emailId: string) {
        this.emailId = emailId;
        this.fileInfo = new Array<FileInfoModel>();
    }
    fileInfo: Array<FileInfoModel>;
    emailId: string;
}

export class FileInfoModel {
    constructor(fileId?: string, fileName?: string, deliveryOrganization?: string) {
        this.fileId = fileId;
        this.fileName = fileName;
        this.deliveryOrganization = deliveryOrganization;
    }
    fileId: string;
    fileName: string;
    deliveryOrganization: string;
}

